// Import Vue
import Vue from 'vue';
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)


// to test

// Import Framework7
import Framework7 from 'framework7/framework7-lite.esm.bundle.js';

// Import Framework7-Vue Plugin
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js';

// Import Framework7 Styles
import 'framework7/css/framework7.bundle.css';
import FontAwesome from 'font-awesome/css/font-awesome.min.css';

// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/app.css';

// Import Icon AZFont Custom Styles
import '../css/az-icon.css';

// Import App Component
import App from '../components/app.vue';


// Init Framework7-Vue Plugin
Framework7.use(Framework7Vue);

// Use v-calendar & v-date-picker components
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

// Register components in your 'main.js'
Vue.component('calendar', Calendar)
Vue.component('date-picker', DatePicker)

var deviceReady = false;
var appMounted = false;


// add cordova.js only if serving the app through file://
if (window.location.protocol === 'file:' || window.location.port === '3000') {
  var cordovaScript = document.createElement('script')
  cordovaScript.setAttribute('type', 'text/javascript')
  cordovaScript.setAttribute('src', 'cordova.js')
  document.body.appendChild(cordovaScript)
}


// Init App
var azconnect = new Vue({
  el: '#app',
  view: {
    pushState: true,
  },
  render: (h) => h(App),
  // Register App Component
  components: {
    app: App
  },
  data(){
    return {
      // apiBaseURL: 'https://azctest.code-zone.me/api/v1/',
      apiBaseURL: 'https://admin.azconnect-web.com/api/v1/',
      // siteURL: 'http://azconnect.local/',
      siteURL: 'https://admin.azconnect-web.com/',
      isLoggedIn: localStorage.getItem('isLoggedIn') ? true : false,
      user: localStorage.getItem('loggedUser') ? JSON.parse(localStorage.getItem('loggedUser')) : {}
    }
  },

  methods: {
    onDeviceReady() {
      console.log('device ready')
      window.FirebasePlugin.grantPermission();
      localStorage.setItem('fcmToken', 'fcm-token')
      this.getDeviceToken()
      this.refereshDeviceToken()
      this.notificationHandlr()
    },
    getDeviceToken: function() {
      window.FirebasePlugin.getToken( (token) => {
        console.log(token);
        localStorage.setItem('fcmToken', token);
        this.updateUserToken()
      }, (error) => {
        console.error(error);
      });
    },
    refereshDeviceToken: function() {
      window.FirebasePlugin.onTokenRefresh( (token) => {
        console.log(token);
        localStorage.setItem('fcmToken', token);
        this.updateUserToken()
      }, (error) => {
        console.error(error);
      });
    },
    notificationHandlr: function() {
      window.FirebasePlugin.onMessageReceived( (notification) => {
        console.log(notification)
        if( notification.action == 'invite_to_event' && localStorage.getItem('loggedUser') ) {
          var event = JSON.parse(notification.event)
          sessionStorage.setItem('currentEvent', JSON.stringify(event))
          this.$f7.view.current.router.navigate( '/event-details/'+ event.id )
        }
        else if( notification.action == 'take_quiz' ) {
          sessionStorage.setItem('currentEvent', notification.event)
          var quiz = JSON.parse(notification.quiz)
          quiz.questions = JSON.parse(notification.questions)
          sessionStorage.setItem('currentQuiz', JSON.stringify(quiz))
          this.$f7.view.current.router.navigate('/quiz/')
        }
        else if ( notification.action == 'activate_user' ) {
          this.$root.user = JSON.parse( notification.user )
          this.$root.authrizeUser(this.$root.user, notification.token)
          this.$root.updateUserToken()
          this.$f7.view.current.router.navigate('/', { clearPreviousHistory: true })
        }
      }, (error) => {
        console.error(error);
      });
    },
    updateUserToken: function() {
      if( localStorage.getItem('loggedUser') ) {
        if( this.user.mobile_token != localStorage.getItem('fcmToken') ) {
          this.user.mobile_token = localStorage.getItem('fcmToken')
          this.$http.post( this.$root.apiBaseURL + 'update-profile', this.user)
            .then( (res) => {
              localStorage.setItem('loggedUser', JSON.stringify(this.user))
            })
            .catch( (error) => {
              console.log(error)
            })
        }
      }
    },
    authrizeUser: function(user, token) {
      this.user = user
      localStorage.setItem('loggedUser', JSON.stringify(user))
      localStorage.setItem('userToken', JSON.stringify(token))
      localStorage.setItem('isLoggedIn', user.id)
      this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
    },
    logoutFromApp() {
      localStorage.removeItem('loggedUser')
      localStorage.removeItem('userToken')
      localStorage.removeItem('isLoggedIn')
      this.axios.defaults.headers.common['Authorization'] = ''
      this.$f7.view.current.router.navigate('/login/')
      this.axios.get(this.apiBaseURL + 'logout')
        .then( (response) => {
          localStorage.removeItem('loggedUser')
          localStorage.removeItem('userToken')
          this.axios.defaults.headers.common['Authorization'] = ''
          this.$f7.view.current.router.navigate('/login/')
        })
        .catch( (error) => {
          console.log('Can not log out right now!!')
        })
    }
  },
  created: function() {
    if (localStorage.getItem('userToken')) {
      this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('userToken').replace('"', '')
    }
  },
  mounted: function() {
    if (!localStorage.getItem('loggedUser')) {
      localStorage.removeItem('loggedUser')
      localStorage.removeItem('userToken')
      this.axios.defaults.headers.common['Authorization'] = ''
      this.$f7.view.current.router.navigate('/login/')
    }
    appMounted = true;
    if (deviceReady) {
      this.onDeviceReady();
    }
  }
});


if ('addEventListener' in document) {
  document.addEventListener("deviceready", onDeviceReady, false);

  function onDeviceReady() {
    console.log('the device is ready')
    deviceReady = true;
    azconnect.deviceReady = true;
    if (appMounted) {
      azconnect.onDeviceReady();
    }


    // handle backbutton
    document.addEventListener("backbutton", onBackKeyDown, false);
    function onBackKeyDown(e) {
      if (azconnect.$f7.view.current.router) {
        var currentPage = azconnect.$f7.view.current.router.url || '/';
        if (currentPage == '/' || currentPage == '/login/') {
          navigator.app.exitApp()
        } else {
          azconnect.$f7.view.current.router.back()
        }
      }
    }
  }
}